module.exports = __webpack_public_path__ + "img/ring_y_s_null_1@3x.33b1f827.png";